import script from "./dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./dialog.vue?vue&type=script&lang=ts&setup=true"

import "./dialog.vue?vue&type=style&index=0&id=23770082&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23770082"]])

export default __exports__